import { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";

import { usePlatform } from "../features/platform-detection/use-platform.js";

export const useDeviceInfo = () => {
  const { getPlatformContext } = usePlatform();
  const [appContext, setAppContext] =
    useState<Awaited<ReturnType<typeof getPlatformContext>>>(null);

  useEffect(() => {
    const loadContext = async () => {
      const context = await getPlatformContext();
      if (context) {
        setAppContext(context);
      }
    };

    loadContext();
  }, [getPlatformContext]);

  // Detects the device the app is running on
  const isMobileDevice =
    appContext === null
      ? false
      : appContext?.app?.host?.clientType === "android" ||
        appContext?.app?.host?.clientType === "ios";

  // Detects the resolution of the device the app is running on
  const isMobileResolution = useMediaQuery({ maxWidth: 768 });

  return {
    isMobile: isMobileResolution || isMobileDevice,
  };
};
